import { render, staticRenderFns } from "./CommodityCreateUpdate.vue?vue&type=template&id=ec1b2ea0"
import script from "./CommodityCreateUpdate.vue?vue&type=script&lang=js"
export * from "./CommodityCreateUpdate.vue?vue&type=script&lang=js"
import style0 from "./CommodityCreateUpdate.vue?vue&type=style&index=0&id=ec1b2ea0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports